import { render, staticRenderFns } from "./PropertyContacts.vue?vue&type=template&id=4311bdff"
import script from "./PropertyContacts.vue?vue&type=script&lang=ts"
export * from "./PropertyContacts.vue?vue&type=script&lang=ts"
import style0 from "./PropertyContacts.vue?vue&type=style&index=0&id=4311bdff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports